module.exports = __webpack_public_path__ + "img/toggle-on-trans.f37ebf04.svg";